<template>
    <div class="printOrderListBox">
        <!-- <el-tabs v-model="activeName" class="orderListTabs">
          <el-tab-pane
            v-for="item in tabList"
            :key="item.id"
            :label="item.name"
            :name="item.id"
          >
          </el-tab-pane>
        </el-tabs> -->
        <div>
            <div class="orderSearchBox">
                <!--        <el-date-picker v-model="createDate" type="date" placeholder="创建时间">
                        </el-date-picker>
                        <el-date-picker v-model="placeDate" type="date" placeholder="申请时间">
                        </el-date-picker>
                        <el-input v-model="orderNum" placeholder="订单编号"></el-input>
                        <el-input v-model="demandName" placeholder="买家昵称"></el-input>
                        <el-select v-model="backStatus" placeholder="退款类型">
                          <el-option label="全部" value="全部"> </el-option>
                          <el-option label="待确认" value="待确认"> </el-option>
                          <el-option label="待付款" value="待付款"> </el-option>
                        </el-select>
                        <el-date-picker v-model="backDate" type="date" placeholder="退款时间">
                        </el-date-picker>
                        <el-input v-model="backMoney" placeholder="退款金额"></el-input>
                        <el-select v-model="backYin" placeholder="退款原因">
                          <el-option label="全部" value="全部"> </el-option>
                          <el-option label="待确认" value="待确认"> </el-option>
                          <el-option label="待付款" value="待付款"> </el-option>
                        </el-select>
                        <el-select v-model="orderType" placeholder="订单类型">
                          <el-option label="设计订单" value="设计订单"> </el-option>
                          <el-option label="模型订单" value="模型订单"> </el-option>
                        </el-select>
                        <el-select v-model="backType" placeholder="退款状态">
                          <el-option label="全部" value="全部"> </el-option>
                          <el-option label="待确认" value="待确认"> </el-option>
                          <el-option label="待付款" value="待付款"> </el-option>
                        </el-select>
                        <el-input v-model="logisticsNum" placeholder="物流单号"></el-input>
                        <el-select v-model="logisticsType" placeholder="物流状态">
                          <el-option label="全部" value="全部"> </el-option>
                          <el-option label="待确认" value="待确认"> </el-option>
                          <el-option label="待付款" value="待付款"> </el-option>
                        </el-select>
                        <el-select v-model="platformIn" placeholder="平台介入">
                          <el-option label="全部" value="全部"> </el-option>
                          <el-option label="待确认" value="待确认"> </el-option>
                          <el-option label="待付款" value="待付款"> </el-option>
                        </el-select>-->
                <el-select v-model="orderType" placeholder="订单类型">
                    <el-option label="设计订单" value="DESIGN"></el-option>
                    <el-option label="模型订单" value="MODEL"></el-option>
                </el-select>
                <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                <el-date-picker v-model="inputDate" type="date" placeholder="申请时间">
                </el-date-picker>
                <el-select v-model="status" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待确认" value="AUDIT"></el-option>
                    <el-option label="已完成" value="DONE"></el-option>
                </el-select>


                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <!--        <div class="tableTool">
                          <div class="toolLeft">
                            <span
                              >已选：
                              <span class="num">{{ multipleSelection.length }}</span></span
                            >
                            <el-button
                              type="primary"
                              plain
                              size="small"
                              :disabled="multipleSelection.length <= 0"
                              >批量发货</el-button
                            >
                            <el-button
                              type="primary"
                              plain
                              size="small"
                              :disabled="multipleSelection.length <= 0"
                              >批量免运费</el-button
                            >
                            <el-button
                              type="primary"
                              plain
                              size="small"
                              :disabled="multipleSelection.length <= 0"
                              >导出订单</el-button
                            >
                          </div>
                        </div>-->
                <ul class="tableHeader">
                    <li class="select">
                        <el-checkbox v-model="checkedAll" @change="tableHeaderChange"
                        >全选
                        </el-checkbox
                        >
                    </li>
                    <li class="price">订单类型</li>
                    <li class="num">订单编号</li>
                    <li class="arguments">售后类型</li>
                    <li class="payment">售后原因</li>
                    <li class="payment">退款金额</li>
                    <li class="status">申请时间</li>
                    <li class="status">状态</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody" v-if="tableList.length != 0" v-loading="loading">
                    <li class="bodyItem" v-for="item in tableList">
                        <div class="itemTop">
                            <el-checkbox
                                v-model="item.checked"
                                style="padding-right: 20px"
                                @change="bodyItemCheckChange"
                            ></el-checkbox>
                            <div>订单编号：{{ item.orderNo }}</div>
                            <div>创建时间：{{ item.createTime }}</div>
                            <div class="merchantInfo">
                                <span>买家：</span>
                                <span>{{ item.creator }}</span>
                                <i class="iconfont icon-weixin" @click="startChat(item.creatorUuid)"></i>
                            </div>
                            <!--<el-button type="text" class="complainBtn">投诉商家</el-button>-->
                        </div>
                        <div class="itemBottom">
                            <div class="select"></div>
                            <div class="price">
                                {{ item.orderTypeCn }}
                            </div>
                            <div class="num">
                                {{ item.orderNo }}
                            </div>
                            <div class="arguments">
                                {{ item.typeCn }}
                            </div>
                            <div class="payment">
                                {{ item.reason }}
                            </div>
                            <div class="payment">
                                {{ item.returnPrice }}
                            </div>
                            <div class="status">
                                {{ item.createTime }}
                            </div>
                            <div class="status">
                                {{ item.statusCn }}
                            </div>
                            <div class="operation">
                                <el-button type="text" class="operationUploadBtn"
                                           @click="handleOrder('detalis', item)"
                                >查看详情
                                </el-button
                                >
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.status === 'AUDIT' && !item.auditStatus"
                                           @click="handleOrder('dealWith', item)"
                                >审核
                                </el-button
                                >
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                     <img src="../../../assets/images/暂无内容.jpg" alt="" style="width:200px">
                </div>
            </div>
            <el-pagination
                v-if="tableList.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
            <!-- 拒绝弹窗 -->
            <el-dialog title="处理" :visible.sync="dealWithMess">
                <el-form :model="form" :rules="rules" ref="form">
                    <el-form-item label="处理：" prop="auditStatus">
                        <el-radio-group v-model="form.auditStatus">
                            <el-radio label="REJECT">拒绝</el-radio>
                            <el-radio label="PASS">同意</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="拒绝原因："
                        prop="auditReason"
                        v-if="form.auditStatus === 'REJECT'"
                    >
                        <el-input type="textarea" v-model="form.auditReason"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dealWithMess = false">取 消</el-button>
                    <el-button type="primary" @click="submitForm('form')"
                    >确 定
                    </el-button
                    >
                </div>
            </el-dialog>
            <!-- 订单详情 -->
            <el-dialog title="详情" :visible.sync="detailsDialog">
                <div class="detailsMEssage">
                    <p>售后类型：</p>
                    <p>{{ formDetails.type }}</p>
                </div>
                <div class="detailsMEssage">
                    <p>售后原因：</p>
                    <p>{{ formDetails.reason }}</p>
                </div>
                <div class="detailsMEssage">
                    <p>退款金额：</p>
                    <p>{{ formDetails.money }}</p>
                </div>
<!--                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailsDialog = false">取 消</el-button>
                    <el-button type="primary" @click="submitForm()"
                    >确 定
                    </el-button
                    >
                </div>-->
            </el-dialog>
        </div>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
import {auditAfterSale, getAfterSaleList, getRongCloudUser} from "../../../utils/interface";
import chatDialog from "../../../components/chat/chatDialog";

export default {
    data() {
        return {
            activeName: "0",
            tabList: [
                {
                    id: "0",
                    name: "全部",
                },
                {
                    id: "1",
                    name: "仅退款（未发货）",
                },
                {
                    id: "2",
                    name: "仅退款（已发货）",
                },
                {
                    id: "3",
                    name: "退款（已发货）",
                },
                {
                    id: "4",
                    name: "维修",
                },
                {
                    id: "5",
                    name: "待评价",
                },
            ],
            createDate: "",
            inputDate: "",
            orderNo: "",
            orderType: "",
            status: "",
            backDate: "",
            backMoney: "",
            backYin: "",
            backType: "",
            logisticsNum: "",
            logisticsType: "",
            platformIn: "",
            multipleSelection: [],
            loading: true,
            tableList: [],
            checkedAll: false,
            // 拒绝弹窗
            dealWithMess: false,
            form: {
                uuid: "",
                auditStatus: "",
                auditReason: "",
            },
            rules: {
                auditStatus: [
                    {required: true, message: "请选择处理意见", trigger: "change"},
                ],
                auditReason: [
                    {required: true, message: "请填写拒绝理由", trigger: "change"},
                ],
            },
            // 详情弹窗
            detailsDialog: false,
            formDetails: {
                type: '售后类型',
                reason: "售后原因",
                money: "￥122",
            },

            current: 1,
            total: 0,
            pageSize: 5,
        };
    },
    components: {
        chatDialog
    },
    created() {
        this.search();
    },
    methods: {
        reset() {
            this.inputDate = "";
            this.orderNo = "";
            this.orderType = "";
            this.status = "";
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        search() {
            this.loading = true
            let params = {
                selectType: "2",
                orderNo: this.orderNo,
                status: this.status,
                orderType: this.orderType,
                type: 'REFUND',
                current: this.current,
                pageSize: this.pageSize
            };
            getAfterSaleList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableList = res.list;
                this.loading = false
            });
        },
        // 列表选择功能
        tableHeaderChange(val) {
            this.tableList.map((item) => {
                item.checked = val;
            });
            if (val) {
                this.multipleSelection = this.tableList;
            } else {
                this.multipleSelection = [];
            }
        },
        bodyItemCheckChange() {
            this.multipleSelection = this.tableList.filter(
                (res) => res.checked === true
            );
            if (this.multipleSelection.length === this.tableList.length) {
                this.checkedAll = true;
            } else {
                this.checkedAll = false;
            }
        },
        // 按钮
        handleOrder(state, item) {
            if (state == "dealWith") {
                this.form.uuid = item.uuid;
                this.dealWithMess = true;
            } else if (state == "detalis") {
                this.formDetails.type = item.typeCn;
                this.formDetails.reason = item.reason;
                this.formDetails.money = item.returnPrice;
                this.detailsDialog = true;
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert("submit!");
                    auditAfterSale(this.form).then((response) => {
                        if (response.success) {
                            this.$message({
                                type: "success",
                                message: "审核成功",
                                duration: 1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                                onClose: () => {
                                    //跳转页面或执行方法
                                    this.$router.go(0);
                                }
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                        this.dealWithMess = false;
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        startChat(targetUuid) {
            let user = this.$store.state.userMessages;
            getRongCloudUser(targetUuid).then(res=> {
                console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
            });
        }
    },
};
</script>

<style scoped lang="less">
.printOrderListBox {
    padding: 20px 20px 20px;

    .orderListTabs {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
    }

    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7;
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #e4e7ed;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }

    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }

    /deep/ .el-tabs__item.is-active {
        color: #3686d7;
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }

    .orderSearchBox {
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .orderListTable {
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356fdf;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157efb;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157efb;
                        box-sizing: border-box;
                        border: 1px solid #157efb;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }

        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;

            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }
        }

        .select {
            padding: 0 20px;
            width: 92px;
        }

        .tableBody {
            .bodyItem {
                margin-bottom: 10px;
            }

            li {
                width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;

                .itemTop {
                    width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            padding-right: 5px;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;
                    margin: 26px 0;

                    .orderInfo {
                        padding: 20px;
                        display: flex;

                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                max-width: 300px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }

                    .arguments {
                        padding: 20px;
                    }

                    .argumentsName {
                        padding-bottom: 8px;
                    }

                    .payment {
                        h3 {
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                        }

                        .title {
                            font-size: 12px;
                            color: #999999;
                        }
                    }

                    .status {
                        font-size: 14px;
                    }

                    .operationBtn {
                        display: block;
                        color: #0c75d3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }
                }
            }
        }

        .name {
            flex: 1;
            position: relative;
        }

        .price {
            width: 120px;
            text-align: center;
        }

        .num {
            width: 95px;
            text-align: center;
        }

        .arguments {
            width: 294px;
            text-align: center;
        }

        .payment {
            width: 162px;
            text-align: center;
        }

        .status {
            width: 124px;
            text-align: center;
        }

        .operation {
            width: 145px;
            text-align: center;

            .operationUploadBtn {
                width: 102px !important;
                height: 34px;
                padding: 0;
                line-height: 34px;
                text-align: center;
                font-weight: 700;
                color: rgba(0, 102, 204, 0.8);
                font-size: 14px;
                border-color: rgba(0, 102, 204, 0.8);
                display: block;
                margin: 0 auto 10px !important;
            }
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}

.detailsMEssage {
    display: flex;
    align-items: center;
    font-size: 14px;

}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/moneyBackOrderList.vue